export enum CertificateEnum {
  standard = 'Standaard',
  nrto = 'NRTO',
}